const clientCompanySelection = {
  welcomeTitle: "Welcome back, {name} 👋",
  welcomeSubtitle:
    "You have {count} active event partnerships requiring your attention today.",
  sectionTitle: "Your Event Partnerships",
  activeCount: "Active: {count}",
  partnerCompany: "Partner company",
  selectCompanyAria: "Open {company} workspace",
  switchCompanyTriggerAria: "Switch company workspace",
  switchCompanyMenuAria: "Available company workspaces",
};

export default clientCompanySelection;
